import React from "react";
import Layout from "./Layout";
import SessionManager from "../SessionManager";

const LayoutContainer = (props) => {
  // SessionManager owns the authenticated-session lifetime: keepalive polling,
  // 2h idle logout, and the session-expiry warning. (Replaces the old
  // react-idle-timer → Cognito signOut wiring.)
  return (
    <>
      <SessionManager />
      <Layout {...props} />
    </>
  );
};

export default LayoutContainer;
